// OUT_OF_AREA NOT_ASSIGNED ASSIGNED ASSIGNED_NOT_ACKNOWLEDGED ASSIGNED_REFUSED
// IN_PROGRESS PAUSED COMPLETED CANCELLED NOT_DONE

export const isFinalState = (orderStatus) => {
    if (!orderStatus) {
        return false;
    }
    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return false;
    }
    return isFinalStateByDispatchStatus(orderStatusItem.get('dispatchStatus'));
};

export const isFinalStateByDispatchStatus = (dispatchStatus) => {
    if (dispatchStatus === 'COMPLETED') {
        return true;
    }

    if (dispatchStatus === 'NOT_DONE') {
        return true;
    }

    if (dispatchStatus === 'CANCELLED') {
        return true;
    }

    return false;
};

export const isAssignedState = (orderStatus) => {
    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return false;
    }
    if (orderStatusItem && orderStatusItem.get('dispatchStatus') === 'ASSIGNED') {
        return true;
    }

    return false;

};

export const isInProgressState = (orderStatus) => {
    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return false;
    }
    if (orderStatusItem && orderStatusItem.get('dispatchStatus') === 'IN_PROGRESS') {
        return true;
    }
    return false;
};

export const isClosingOrderState = (orderStatus) => {
    if (!orderStatus) {
        return false;
    }
    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return false;
    }
    if (orderStatusItem && orderStatusItem.get('dispatchStatus') === 'Closing order') {
        return true;
    }
    return false;
};

export const isFailedState = (orderStatus) => {
    if (!orderStatus) {
        return false;
    }
    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return false;
    }
    if (orderStatusItem && orderStatusItem.get('dispatchStatus') === 'Error') {
        return true;
    }
    return false;
};


// WEBPACK FOOTER //
// ./src/utils/orderStatusUtils.js